import { DESTINATION_URL_HINT, PREFIX_NAME_HINT } from './prefixNameRules';
/** Пояснения к полям префикса ретрансляции (диалог + заголовки таблицы). */
export const PREFIX_FIELD_HINTS = {
    active: 'Включён — ретрансляция по префиксу идёт; выключен — пауза, группы и настройки сохраняются.',
    prefix: PREFIX_NAME_HINT,
    protocol: 'Обязательно выберите протокол доставки: XML, WIALON, EGTS или POST.',
    type: 'Тип пакета Wialon IPS: SD или D. Для других протоколов не используется.',
    url: DESTINATION_URL_HINT,
    groups: 'Транспортные группы, на которые действует префикс. Введите имя для поиска, отметьте несколько групп подряд.',
    dFlags: 'Параметры пакета #D# (только WIALON + тип D). Флаги независимы — можно включать в любой комбинации.',
    sendSensors: 'Передавать датчики ДУТ/ДУН (dtN, duN, duk) в #D#.',
    sendGuards: 'Передавать статус охраны (grd) в #D#.',
    sendAlarms: 'Передавать статус тревоги (alrm) в #D#.',
};
